var React = require('react');

function Location (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.66683 7.00294C9.66683 6.0821 8.92067 5.33594 8.0005 5.33594C7.07965 5.33594 6.3335 6.0821 6.3335 7.00294C6.3335 7.92311 7.07965 8.66927 8.0005 8.66927C8.92067 8.66927 9.66683 7.92311 9.66683 7.00294Z","stroke":"#BDBDBD","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.99967 14C7.20069 14 3 10.5989 3 7.04219C3 4.25776 5.23807 2 7.99967 2C10.7613 2 13 4.25776 13 7.04219C13 10.5989 8.79866 14 7.99967 14Z","stroke":"#BDBDBD","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Location.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Location;

Location.default = Location;
